module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_5012.1666d23d.png";